import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    countingBadge: {
        marginLeft: "auto",
        marginRight: theme.spacing(2),
        "& .MuiBadge-badge": {
            "&:hover": {
                opacity: 0.5,
            },
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.common.white,
        },
    },
}));
